import React from 'react';
import Chartjs from 'chart.js';

class Chart extends React.Component {

  constructor(props) {
    super(props);

    this.chartCanvas = React.createRef();

    this.state = {
      advancedChart: false,
      advancedChartVisible: false
    }

    this.brewData = [];
    this.brewChart = {};
    this.brewDataAdvanced = this.brewDataAdvanced || [];
  };

	addAdvancedData = () => {
		this.brewChart.data.datasets.push({
			labels: [
				'Brown Sugar',
				'Vanilla',
				'Vanillin',
				'Overall Sweet',
				'Sweet Aromatics',
				'Black Tea',
				'Berry',
				'Dried Fruit',
				'Other Fruit',
				'Citrus Fruit',
				'Alcohol/Fermented',
				'Olive Oil',
				'Raw',
				'Beany',
				'Papery/Musty',
				'Chemical',
				'Cereal',
				'Burnt',
				'Tobacco',
				'Pipe Tobacco',
				'Brown Spice',
				'Pepper',
				'Pungent',
				'Cocoa',
			],
			backgroundColor: [
				'#d45959', // Brown sugar
				'#f89a80', // Vanilla
				'#f37574', // Vanillin
				'#e75a68', // Overall sweet
				'#d0545f', // Sweet aromatics
				'#975d6d', // Black tea
				'#dd4b51', // Berry
				'#c94a44', // Dried fruit
				'#f2684b', // Other fruit
				'#f7a028', // Citrus
				'#b09733', // Alcohol/Fermented
				'#a2af2a', // Olive oil
				'#718933', // Raw
				'#5f9a80', // Beany
				'#9db2b7', // Papery/Musty
				'#76c0cb', // Chemical
				'#ddae61', // Cereal
				'#be8663', // Burnt
				'#dfbc7e', // Tobacco
				'#caa465', // Pipe
				'#b14c57', // Brown Spice
				'#cc3c41', // Peper
				'#794752', // Pungent
				'#c78869', // Cocoa
			],
			datalabels: {
				anchor: 'center',
				// rotation: 70
			},
      borderWidth: 0,
			data: this.brewDataAdvanced
		});

		this.setState({
			...this.state.advancedChart,
			advancedChartVisible: true
		});

		this.brewChart.update();
	};

	removeAdvancedChart = () => {
		this.brewChart.data.datasets.pop();
		this.brewChart.update();
		this.setState({
			...this.state.advancedChart,
			advancedChartVisible: false
		});
	};

  createChart = () => {
    this.setState({
      ...this.state.advancedChartVisible,
      advancedChart: this.props.advancedChart
    });

    this.brewData = [this.props.brew.taste_sweet, this.props.brew.taste_floral, this.props.brew.taste_fruity, this.props.brew.taste_sour, this.props.brew.taste_green_vegetative, this.props.brew.taste_other, this.props.brew.taste_roasted, this.props.brew.taste_spices, this.props.brew.taste_nutty_cocoa];
    this.brewDataAdvanced = [this.props.brew.sweet_brown_sugar, this.props.brew.sweet_vanilla, this.props.brew.sweet_vanillin, this.props.brew.sweet_overall_sweet, this.props.brew.sweet_sweet_aromatics, this.props.brew.floral_black_tea, this.props.brew.fruity_berry, this.props.brew.fruity_dried_fruit, this.props.brew.fruity_other_fruit, this.props.brew.fruity_citrus_fruit, this.props.brew.sour_alcohol_fermented, this.props.brew.green_vegetative_olive_oil, this.props.brew.green_vegetative_raw, this.props.brew.green_vegetative_beany, this.props.brew.other_papery_musty, this.props.brew.other_chemical, this.props.brew.roasted_cereal, this.props.brew.roasted_burnt, this.props.brew.roasted_tobacco, this.props.brew.roasted_pipe_tobacco, this.props.brew.spices_brown_spice, this.props.brew.spices_pepper, this.props.brew.spices_pungent, this.props.brew.nutty_cocoa_cocoa];
    this.brewChart = new Chartjs(this.chartCanvas.current, {
      type: 'doughnut',
      // plugins: [ChartDataLabels],
      data: {
        datasets: [{
          data: this.brewData,
          backgroundColor: [
            '#e65832', // Sweet
            '#da0e68', // Floral
            '#da1c23', // Fruity
            '#ebb30e', // Sour/Fermented
            '#177a2e', // Green/Vegetative
            '#0ba3b4', // Other
            '#c9482f', // Roaster
            '#ad213d', // Spices
            '#a87b63'  // Nutty/Cocoa
          ],
          labels: [
            'Sweet',
            'Floral',
            'Fruity',
            'Sour/Fermented',
            'Green/Vegetative',
            'Other',
            'Roasted',
            'Spices',
            'Nutty/Cocoa'
          ],
          datalabels: {
            anchor: 'center'
          },
          borderWidth: 0
        }]
      },
      options: {
        cutoutPercentage: 30,
        animation: {
          animateScale: true,
        },
        maintainAspectRatio: false,
        legend: false,
        tooltips: false
      },
    });
  };

	componentDidMount() {
		this.createChart();
	};

	componentDidUpdate(prevProps, prevState, snapshot) {
		if(this.props !== prevProps || this.state !== prevState) { // Makes sure the graph doesn't get updated infinite times
			this.brewData = [this.props.brew.taste_sweet, this.props.brew.taste_floral, this.props.brew.taste_fruity, this.props.brew.taste_sour, this.props.brew.taste_green_vegetative, this.props.brew.taste_other, this.props.brew.taste_roasted, this.props.brew.taste_spices, this.props.brew.taste_nutty_cocoa];
			this.brewDataAdvanced = [this.props.brew.taste_sweet_brown_sugar, this.props.brew.taste_sweet_vanilla, this.props.brew.taste_sweet_vanillin, this.props.brew.taste_sweet_overall_sweet, this.props.brew.taste_sweet_sweet_aromatics, this.props.brew.taste_floral_black_tea, this.props.brew.taste_fruity_berry, this.props.brew.taste_fruity_dried_fruit, this.props.brew.taste_fruity_other_fruit, this.props.brew.taste_fruity_citrus_fruit, this.props.brew.taste_sour_alcohol_fermented, this.props.brew.taste_green_vegetative_olive_oil, this.props.brew.taste_green_vegetative_raw, this.props.brew.taste_green_vegetative_beany, this.props.brew.taste_other_papery_musty, this.props.brew.taste_other_chemical, this.props.brew.taste_roasted_cereal, this.props.brew.taste_roasted_burnt, this.props.brew.taste_roasted_tobacco, this.props.brew.taste_roasted_pipe_tobacco, this.props.brew.taste_spices_brown_spice, this.props.brew.taste_spices_pepper, this.props.brew.taste_spices_pungent, this.props.brew.taste_nutty_cocoa_cocoa];

			if(Object.keys(this.brewChart).length > 0) { // Doublecheck to make sure brewChart already exists
				if(this.props.advancedChart) {
					if(!this.state.advancedChartVisible) {
						this.addAdvancedData();
					}
					this.brewChart.data.datasets[0].data = this.brewData;
					this.brewChart.data.datasets[1].data = this.brewDataAdvanced;
				} else {
					if(this.state.advancedChartVisible) {
						this.removeAdvancedChart();
					}
					this.brewChart.data.datasets[0].data = this.brewData;
				}

				this.brewChart.update();
			}
		}
	};

  componentWillUnmount() {
    this.brewChart.destroy();
  };

	render() {
		return (
			<div className="brew-chart">
				<canvas className="brew-chart__canvas" ref={ this.chartCanvas }></canvas>
			</div>
		)
	}
}

export default Chart;
